import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import {Util,Context,Hooks} from "@xt/xtbase";
const {getOrigin} = Util;
const {useTranslation} = Hooks;
import FinanceHead from "@/components/Pages/Finance/FinanceHead";
import FinanceFaq from "@/components/Pages/Finance/FinanceFaq";
import ModalSubscribe from "@/components/Pages/Finance/ModalSubscribe";
import PageStaking from "@/components/Pages/Finance/PageStaking";
import models from "@/models";

export default (props)=>{
  models?.finance?.setScope("STAKING");
  const t = useTranslation();
  return (
    <>
      <Script
        id="jsonLd"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            {
              "@context":"http://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "${t('finance.faqStaking1').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking1Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking2').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking2Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking3').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking3Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking4').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking4Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking5').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking5Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking6').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking6Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking7').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking7Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqStaking8').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqStaking8Answer').replace(/\"/g,'')}</p>"
                }
              }]
            }
          `,
        }}
      />
      <Layout style={{overflow: "hidden"}}>
        <FinanceHead category={2}/>
        <PageStaking/>
        <FinanceFaq category={2}/>
        <ModalSubscribe/>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/finance/staking";
  const props = {resolvedUrl,theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}



